/* ===========================================================
   🔗 HumanAlloy → Gumroad GCLID bridge  (ha-gclid-bridge-v1.js)
   Captures Google Ads click IDs and forwards them on every
   outbound Gumroad link, so a Gumroad sale can later be
   matched back to the originating ad click via offline
   conversion import.
   =========================================================== */
(function () {
  "use strict";

  var COOKIE_NAME   = "ha_gclid";
  var COOKIE_DAYS   = 90;                          // 📅 max Google Ads click window
  var GUMROAD_HOSTS = ["gumroad.com"];             // ➕ add your own Gumroad domain if you use one
  var CLICK_KEYS    = ["gclid", "gbraid", "wbraid"]; // 🆔 Google click identifiers (web + iOS)

  // --- cookie helpers --------------------------------------
  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie =
      name + "=" + encodeURIComponent(value) +
      ";expires=" + d.toUTCString() +
      ";path=/;SameSite=Lax;Secure";
  }
  function getCookie(name) {
    var m = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)");
    return m ? decodeURIComponent(m.pop()) : "";
  }

  // --- 1) capture the click id from the landing URL --------
  function captureClickId() {
    var params = new URLSearchParams(window.location.search);
    for (var i = 0; i < CLICK_KEYS.length; i++) {
      var val = params.get(CLICK_KEYS[i]);
      if (val) {
        // store as "key:value" so we know which identifier it is
        setCookie(COOKIE_NAME, CLICK_KEYS[i] + ":" + val, COOKIE_DAYS);
        console.log("✅ [HA] click id captured:", CLICK_KEYS[i]);
        return CLICK_KEYS[i] + ":" + val;
      }
    }
    return getCookie(COOKIE_NAME); // 🔁 reuse stored id on later pageviews
  }

  // --- 2) append the stored id to a single Gumroad URL -----
  function decorate(href, stored) {
    if (!stored) return href;
    var parts = stored.split(":");
    var key   = parts[0];
    var value = parts.slice(1).join(":");
    try {
      var url = new URL(href, window.location.origin);
      var isGumroad = GUMROAD_HOSTS.some(function (h) {
        return url.hostname.indexOf(h) !== -1;
      });
      if (!isGumroad) return href;
      if (!url.searchParams.has(key)) {
        url.searchParams.set(key, value);
      }
      return url.toString();
    } catch (e) {
      return href; // ⚠️ malformed url, leave it untouched
    }
  }

  // --- 3) rewrite every Gumroad link on the page -----------
  function rewriteLinks(stored) {
    if (!stored) return;
    var links = document.querySelectorAll('a[href*="gumroad.com"]');
    var count = 0;
    links.forEach(function (a) {
      var current = a.getAttribute("href");
      var updated = decorate(current, stored);
      if (updated !== current) {
        a.setAttribute("href", updated);
        count++;
      }
    });
    if (count) console.log("🔗 [HA] gumroad links decorated:", count);
  }

  // --- run -------------------------------------------------
  var stored = captureClickId();
  document.addEventListener("DOMContentLoaded", function () {
    rewriteLinks(stored);
    // 👀 re-run for cards added later (infinite scroll, filters)
    var observer = new MutationObserver(function () { rewriteLinks(stored); });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
